export default __webpack_public_path__ + "static/media/icon-credit.d5945c03.svg";